import { useMutation, useQueryClient } from '@tanstack/react-query'
import { z } from 'zod'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import { contractDayReservableAreasKey } from './useAPIGetContractDayReservableAreas'

import { post } from 'api/apiClient'

type CancelReservationPayload = {
  rentableHierarchyId: number
}

const cancelReservation = (
  contractUuid: string,
  payload: CancelReservationPayload
) =>
  post<void>(
    API_ENDPOINTS.CONTRACT_DAY_RESERVABLE_AREA_RESERVATIONS_CANCEL.replace(
      ':contractUuid',
      contractUuid
    ),
    payload,
    z.void()
  )

export const useAPICancelContractDayReservableAreaReservation = (
  contractUuid: string | undefined
) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: CancelReservationPayload) => {
      if (!contractUuid) throw new Error('Contract UUID is required')
      return cancelReservation(contractUuid, payload)
    },
    onSuccess: () => {
      if (contractUuid) {
        queryClient.invalidateQueries({
          queryKey: contractDayReservableAreasKey(contractUuid, 'all'),
        })
        queryClient.invalidateQueries({
          queryKey: contractDayReservableAreasKey(contractUuid, 'own'),
        })
        queryClient.invalidateQueries({
          queryKey: ['extra-service-reservations', contractUuid],
        })
      }
    },
  })
}
